import React from "react"
import styled from "styled-components"

import { Column } from "@ui-kit/helpers"

export default ({ heading, body }) => (
  <Column>
    <Style>
      <summary>{heading}</summary>
      <div dangerouslySetInnerHTML={{ __html: body.html }} />
    </Style>
  </Column>
)

const Style = styled.details.attrs((props) => ({
  className: "promotion",
}))`
  margin-top: 1vh;

  > summary {
    font-weight: 600;
    font-size: 2em;
    text-align: center;
    cursor: pointer;
  }

  &[open] > summary {
    color: ${(props) => props.theme.colors.primary};
  }

  > div {
    font-size: 82.5%;
    line-height: 1.4;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;

    > *:first-child {
      margin-top: 1vh;
    }
  }

  h2,
  h3,
  h4 {
    font-weight: 600;
  }
`
